/**
 * What the family's enrollment pages (the year's enroll page, a step, and the
 * old enrollment page that sends them on) say the same way.
 */
import type { ReactNode } from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '~/components/ui/card';

export const NO_ENROLLMENT = 'No enrollment for this school year yet.';

export function Notice({ title, children }: { title: string; children: ReactNode }) {
  return (
    <Card>
      <CardHeader><CardTitle>{title}</CardTitle></CardHeader>
      <CardContent><p className="text-muted-foreground">{children}</p></CardContent>
    </Card>
  );
}

/**
 * A child's grade as the family reads it. Schools name their grades
 * ("3rd Grade", "Kindergarten"), so a name is shown as it is; a bare number
 * reads "Grade 5".
 */
export function gradeLabel(grade: string): string {
  const trimmed = grade.trim();
  return /^\d+$/.test(trimmed) ? `Grade ${trimmed}` : trimmed;
}
